class Cart {
    constructor() {
        this.setupQuantityInputs();
    }

    setupQuantityInputs() {
        const cartManager = this;
        document.addEventListener('click', function (e) {
            try {
                // If the click happened on an element inside the button (icon/span), .closest fixes that.
                const btn = e.target.closest('.qty-increase, .qty-decrease');
                if (!btn) return; // not a qty button — ignore

                e.preventDefault();

                // Find the closest cart-item container so queries are scoped correctly.
                const cartItem = btn.closest('.cart-item') || btn.closest('.cart-item-actions');
                if (!cartItem) {
                    console.warn('No .cart-item or .cart-item-actions ancestor found for', btn);
                    return;
                }

                // Find the qty display element. It might be <input> or a span/div.
                let qtyEl = cartItem.querySelector('.qty-display');
                if (!qtyEl) {
                    console.warn('No .qty-display element found inside', cartItem);
                    return;
                }

                // Read current quantity robustly
                let currentQty = 0;
                if (qtyEl.tagName === 'INPUT' || qtyEl.tagName === 'SELECT') {
                    currentQty = parseInt(qtyEl.value, 10) || 0;
                } else {
                    // for span/div text
                    currentQty = parseInt(qtyEl.textContent.trim(), 10) || 0;
                }

                // Increase
                if (btn.classList.contains('qty-increase')) {
                    if (btn.disabled) {
                        console.log('Increase button is disabled');
                        return;
                    }

                    //get max attr on qtyEl
                    let maxQty = qtyEl.getAttribute('max');
                    if(currentQty+1 > maxQty){
                        console.log('Max quantity reached');
                        return;
                    }

                    currentQty++;
                    if (qtyEl.tagName === 'INPUT' || qtyEl.tagName === 'SELECT') {
                        qtyEl.value = currentQty;
                    } else {
                        qtyEl.textContent = currentQty;
                    }
                    cartManager.triggerUpdateCartButton();
                    return;
                }

                // Decrease
                if (btn.classList.contains('qty-decrease')) {
                    if (currentQty > 1) {
                        currentQty--;
                        if (qtyEl.tagName === 'INPUT' || qtyEl.tagName === 'SELECT') {
                            qtyEl.value = currentQty;
                        } else {
                            qtyEl.textContent = currentQty;
                        }
                        cartManager.triggerUpdateCartButton();
                    } else {
                        // confirm delete
                        const messageDelete = "آیا از حذف این کالا اطمینان دارید؟";
                        if (confirm(messageDelete)) {
                            const removeLink = cartItem.querySelector('a.remove');
                            if (removeLink) {
                                removeLink.click();
                            } else {
                                console.warn('No remove link found in', cartItem);
                            }
                        }
                    }
                    return;
                }
            } catch (err) {
                console.error('Error handling qty click:', err);
            }
        });
    }

    triggerUpdateCartButton() {
        const updateBtn = document.querySelector('button[name="update_cart"], input[name="update_cart"]');
        if (updateBtn) {
            updateBtn.disabled = false;
            updateBtn.classList.remove('disabled');
            updateBtn.removeAttribute('aria-disabled');
            updateBtn.click();
        }
    }
}

//Document loaded event
document.addEventListener("DOMContentLoaded", () => {
    let cart = new Cart();
});